import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function UserTable({ users, query, onQueryChange, onAddPoints }) {
  const navigate = useNavigate();
  const { rows = [], total = 0, page = 1, limit = 25 } = users;
  const totalPages = Math.ceil(total / limit);

  const handleSort = (col) => {
    onQueryChange(prev => ({
      ...prev,
      sort: col,
      order: prev.sort === col && prev.order === 'desc' ? 'asc' : 'desc',
    }));
  };

  const sortIcon = (col) => {
    if (query.sort !== col) return '';
    return query.order === 'asc' ? ' ^' : ' v';
  };

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
        <h3>Users ({total})</h3>
        <input
          placeholder="Search username..."
          value={query.search || ''}
          onChange={e => onQueryChange(prev => ({ ...prev, search: e.target.value, page: 1 }))}
          style={{ width: 200, maxWidth: '100%' }}
        />
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table>
          <thead>
            <tr>
              <th onClick={() => handleSort('username')}>Username{sortIcon('username')}</th>
              <th onClick={() => handleSort('points')}>Points{sortIcon('points')}</th>
              <th onClick={() => handleSort('spin_tokens')}>Spins{sortIcon('spin_tokens')}</th>
              <th className="hide-mobile" onClick={() => handleSort('last_login_at')}>Last Login{sortIcon('last_login_at')}</th>
              <th className="hide-mobile">Invite Code</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(u => (
              <tr key={u.id}>
                <td>
                  <strong>{u.username}</strong>
                  {u.is_admin && <span className="badge badge-rare" style={{ marginLeft: 6 }}>admin</span>}
                </td>
                <td style={{ color: 'var(--warning)' }}>{u.points}</td>
                <td>{u.spin_tokens}</td>
                <td className="hide-mobile" style={{ fontSize: 12 }}>
                  {u.last_login_at ? new Date(u.last_login_at).toLocaleString() : 'Never'}
                </td>
                <td className="hide-mobile" style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                  {u.invite_code || '-'}
                </td>
                <td>
                  <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                    <button className="btn-success btn-small" onClick={() => onAddPoints(u)}>+ Points</button>
                    <button className="btn-secondary btn-small" onClick={() => navigate(`/admin/users/${u.id}`)}>View</button>
                  </div>
                </td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={6} style={{ textAlign: 'center', color: 'var(--text-muted)' }}>No users found</td></tr>
            )}
          </tbody>
        </table>
      </div>
      {totalPages > 1 && (
        <div className="pagination">
          <button
            className="btn-secondary btn-small"
            disabled={page <= 1}
            onClick={() => onQueryChange(prev => ({ ...prev, page: prev.page - 1 }))}
          >Prev</button>
          <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>
            Page {page} of {totalPages}
          </span>
          <button
            className="btn-secondary btn-small"
            disabled={page >= totalPages}
            onClick={() => onQueryChange(prev => ({ ...prev, page: prev.page + 1 }))}
          >Next</button>
        </div>
      )}
    </div>
  );
}
